<ada-card
	#GeneralPropertiesCard
	id="GeneralPropertiesCard"
	verticalSpacing="Small"
	width="100%"
	[collapseEnabled]="true"
>
	<ada-text
		content="General Properties"
		data-container-selector="ada-card-header"
		id="GeneralPropertiesCardHeader"
	/>
	<ada-container
		data-container-selector="ada-card-body"
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[colCount]="4"
		[padding]="defaultCardPadding"
	>
		@if ('ExpiredByVendor' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#ExpiredByVendorLabel
				id="ExpiredByVendorLabel"
				[content]="'Expired By Vendor'"
				[isDisabled]="isDisabled"
				[isRequired]="'ExpiredByVendor' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-toggle-switch
				#ExpiredByVendorInput
				id="ExpiredByVendorInput"
				[isDisabled]="isDisabled"
				[isToggled]="currentPropertyObject?.ExpiredByVendor"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				(isToggledChange)="setObjectPropertyValue('ExpiredByVendor', $event)"
			/>
		}

		@if ('Name' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#NameLabel
				id="NameLabel"
				[content]="'Name'"
				[inheriting]="currentPropertyObject?.Name | inheritPipe:inheritedPropertyObject?.Name"
				[isDisabled]="isDisabled"
				[isRequired]="'Name' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-input
				#NameInput
				id="NameInput"
				type="text"
				[debounce]="100"
				[isDisabled]="isDisabled"
				[maxCharacterLimit]="255"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[showAsFullWidth]="true"
				[value]="currentPropertyObject?.Name"
				(valueChange)="setObjectPropertyValue('Name', $event)"
			/>
		}

		@if ('ShortName' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#ShortNameLabel
				content="Short Name"
				id="ShortNameLabel"
				[isDisabled]="isDisabled"
				[isRequired]="'ShortName' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-input
				#ShortNameInput
				id="ShortNameInput"
				[debounce]="100"
				[isDisabled]="isDisabled"
				[maxCharacterLimit]="255"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[showAsFullWidth]="true"
				[type]="'text'"
				[value]="currentPropertyObject?.ShortName"
				(valueChange)="setObjectPropertyValue('ShortName', $event)"
			/>
		}

		@if ('Description' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#DescriptionLabel
				content="Description"
				id="DescriptionLabel"
				[inheriting]="currentPropertyObject?.Description | inheritPipe:inheritedPropertyObject?.Description"
				[isDisabled]="isDisabled"
				[isRequired]="'Description' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('Description')"
			/>
			<ada-input
				#DescriptionInput
				id="DescriptionInput"
				type="textarea"
				[debounce]="100"
				[isDisabled]="isDisabled"
				[maxCharacterLimit]="8000"
				[minHeight]="'120px'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[showAsFullWidth]="true"
				[value]="!(currentPropertyObject?.Description | inheritPipe) ? currentPropertyObject?.Description : inheritedPropertyObject?.Description"
				(userInput)="setObjectPropertyValue('Description', $event)"
			/>
		}

		@if ('VendorVersion' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#VendorVersionLabel
				content="Vendor Version"
				id="VendorVersionLabel"
				[isDisabled]="isDisabled"
				[isRequired]="'VendorVersion' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-input
				#VendorVersionInput
				id="VendorVersionInput"
				[debounce]="100"
				[isDisabled]="isDisabled"
				[maxCharacterLimit]="255"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[showAsFullWidth]="true"
				[type]="'text'"
				[value]="currentPropertyObject?.VendorVersion"
				(valueChange)="setObjectPropertyValue('VendorVersion', $event)"
			/>
		}

		@if ('VendorName' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#VendorNameLabel
				content="Vendor Name"
				id="VendorNameLabel"
				[isDisabled]="isDisabled"
				[isRequired]="'VendorName' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-input
				#VendorNameInput
				id="VendorNameInput"
				type="text"
				[debounce]="100"
				[isDisabled]="isDisabled"
				[maxCharacterLimit]="255"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[showAsFullWidth]="true"
				[value]="currentPropertyObject?.VendorName"
				(valueChange)="setObjectPropertyValue('VendorName', $event)"
			/>
		}

		@if ('ReleaseDate' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#ReleaseDateLabel
				content="Release Date"
				id="ReleaseDateLabel"
				[isDisabled]="isDisabled"
				[isRequired]="'ReleaseDate' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-input
				#ReleaseDateInput
				id="ReleaseDateInput"
				[isDisabled]="isDisabled"
				[outputDateAsInteger]="true"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[type]="'date-time'"
				[value]="currentPropertyObject?.ReleaseDate"
				(valueChange)="setObjectPropertyValue('ReleaseDate', $event)"
			/>
		}

		@if ('ReleaseNotes' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#ReleaseNotesLabel
				content="Release Notes"
				id="ReleaseNotesLabel"
				[inheriting]="currentPropertyObject?.ReleaseNotes | inheritPipe:inheritedPropertyObject?.ReleaseNotes"
				[isDisabled]="isDisabled"
				[isRequired]="'ReleaseNotes' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('ReleaseNotes')"
			/>
			<ada-input
				#ReleaseNotesInput
				id="ReleaseNotesInput"
				type="textarea"
				[debounce]="100"
				[isDisabled]="isDisabled"
				[maxCharacterLimit]="8000"
				[minHeight]="'120px'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[showAsFullWidth]="true"
				[value]="(currentPropertyObject?.ReleaseNotes !== undefined) ? currentPropertyObject?.ReleaseNotes : inheritedPropertyObject?.ReleaseNotes"
				(userInput)="setObjectPropertyValue('ReleaseNotes', $event)"
			/>
		}

		@if ('AdditionalInformationUrl' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#AdditionalInformationUrlLabel
				id="AdditionalInformationUrlLabel"
				[content]="'Additional Information URL'"
				[inheriting]="currentPropertyObject?.AdditionalInformationUrl | inheritPipe:inheritedPropertyObject?.AdditionalInformationUrl"
				[isDisabled]="isDisabled"
				[isRequired]="'AdditionalInformationUrl' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('AdditionalInformationUrl')"
			/>
			<ada-input
				#AdditionalInformationUrlInput
				id="AdditionalInformationUrlInput"
				type="text"
				[debounce]="100"
				[isDisabled]="isDisabled"
				[maxCharacterLimit]="255"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[showAsFullWidth]="true"
				[value]="(currentPropertyObject?.AdditionalInformationUrl !== undefined) ? currentPropertyObject?.AdditionalInformationUrl : inheritedPropertyObject?.AdditionalInformationUrl"
				(userInput)="setObjectPropertyValue('AdditionalInformationUrl', $event)"
			/>
		}

		@if ('MsiGuid' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#MsiGuidLabel
				content="MSI GUID"
				id="MsiGuidLabel"
				[inheriting]="currentPropertyObject?.MsiGuid | inheritPipe:inheritedPropertyObject?.MsiGuid"
				[isDisabled]="isDisabled"
				[isRequired]="'MsiGuid' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('MsiGuid')"
			/>
			<ada-input
				#MsiGuidInput
				id="MsiGuidInput"
				type="text"
				[debounce]="100"
				[isDisabled]="isDisabled"
				[maxCharacterLimit]="255"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[showAsFullWidth]="true"
				[value]="(currentPropertyObject?.MsiGuid !== undefined) ? currentPropertyObject?.MsiGuid : inheritedPropertyObject?.MsiGuid"
				(userInput)="setObjectPropertyValue('MsiGuid', $event)"
			/>
		}

		@if ('IsSecurityUpdate' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#IsSecurityUpdateLabel
				content="Is Security Update"
				id="IsSecurityUpdateLabel"
				[inheriting]="currentPropertyObject?.IsSecurityUpdate | inheritPipe:inheritedPropertyObject?.IsSecurityUpdate"
				[isDisabled]="isDisabled"
				[isRequired]="'IsSecurityUpdate' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('IsSecurityUpdate')"
			/>
			<ada-toggle-switch
				#IsSecurityUpdateInput
				id="IsSecurityUpdateInput"
				[isDisabled]="isDisabled"
				[isToggled]="currentPropertyObject?.IsSecurityUpdate"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				(isToggledChange)="setObjectPropertyValue('IsSecurityUpdate', $event)"
			/>
		}

		@if ('IsUpdateRollup' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#IsUpdateRollupLabel
				id="IsUpdateRollupLabel"
				[content]="'Is Update Rollup'"
				[inheriting]="currentPropertyObject?.IsUpdateRollup | inheritPipe:inheritedPropertyObject?.IsUpdateRollup"
				[isDisabled]="isDisabled"
				[isRequired]="'IsUpdateRollup' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('IsUpdateRollup')"
			/>
			<ada-toggle-switch
				#IsUpdateRollupInput
				id="IsUpdateRollupInput"
				[isDisabled]="isDisabled"
				[isToggled]="currentPropertyObject?.IsUpdateRollup"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				(isToggledChange)="setObjectPropertyValue('IsUpdateRollup', $event)"
			/>
		}
		
		@if ('IsMinorFeature' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#IsMinorFeatureLabel
				content="Is Minor Feature"
				id="IsMinorFeatureLabel"
				[inheriting]="currentPropertyObject?.IsMinorFeature | inheritPipe:inheritedPropertyObject?.IsMinorFeature"
				[isDisabled]="isDisabled"
				[isRequired]="'IsMinorFeature' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('IsMinorFeature')"
			/>
			<ada-toggle-switch
				#IsMinorFeatureInput
				id="IsMinorFeatureInput"
				[isDisabled]="isDisabled"
				[isToggled]="currentPropertyObject?.IsMinorFeature"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				(isToggledChange)="setObjectPropertyValue('IsMinorFeature', $event)"
			/>
		}

		@if ('IsMajorFeature' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#IsMajorFeatureLabel
				content="Is Major Feature"
				id="IsMajorFeatureLabel"
				[inheriting]="currentPropertyObject?.IsMajorFeature | inheritPipe:inheritedPropertyObject?.IsMajorFeature"
				[isDisabled]="isDisabled"
				[isRequired]="'IsMajorFeature' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('IsMajorFeature')"
			/>
			<ada-toggle-switch
				#IsMajorFeatureInput
				id="IsMajorFeatureInput"
				[isDisabled]="isDisabled"
				[isToggled]="currentPropertyObject?.IsMajorFeature"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				(isToggledChange)="setObjectPropertyValue('IsMajorFeature', $event)"
			/>
		}

		@if ('IsServicepack' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#IsServicepackLabel
				content="Is Service Pack"
				id="IsServicepackLabel"
				[inheriting]="currentPropertyObject?.IsServicepack | inheritPipe:inheritedPropertyObject?.IsServicepack"
				[isDisabled]="isDisabled"
				[isRequired]="'IsServicepack' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('IsServicepack')"
			/>
			<ada-toggle-switch
				#IsServicepackInput
				id="IsServicepackInput"
				[isDisabled]="isDisabled"
				[isToggled]="currentPropertyObject?.IsServicepack"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				(isToggledChange)="setObjectPropertyValue('IsServicepack', $event)"
			/>
		}

		@if ('IsBugfix' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#IsBugfixLabel
				content="Is Bug Fix"
				id="IsBugfixLabel"
				[inheriting]="currentPropertyObject?.IsBugfix | inheritPipe:inheritedPropertyObject?.IsBugfix"
				[isDisabled]="isDisabled"
				[isRequired]="'IsBugfix' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('IsBugfix')"
			/>
			<ada-toggle-switch
				#IsBugfixInput
				id="IsBugfixInput"
				[isDisabled]="isDisabled"
				[isToggled]="currentPropertyObject?.IsBugfix"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				(isToggledChange)="setObjectPropertyValue('IsBugfix', $event)"
			/>
		}
		
		@if ('TargetType' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) {
			<ada-authoring-property-label
				#TargetTypeLabel
				content="Target Type"
				id="TargetTypeLabel"
				[isDisabled]="isDisabled"
				[isRequired]="'TargetType' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-combo
				#TargetTypeInput
				id="TargetTypeInput"
				[isDisabled]="isDisabled"
				[options]="targetTypeOptions"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[value]="currentPropertyObject?.TargetType"
				(userChange)="setObjectPropertyValue('TargetType', $event)"
			/>
		}
		
		@if ('WhoAmI' | displayAuthoringProperty : editorClass : propertyConstructor.namespace) {
			<ada-authoring-property-label
				#WhoAmILabel
				content="Who Am I"
				id="WhoAmILabel"
				[isDisabled]="isDisabled"
				[isRequired]="'WhoAmI' | isRequiredProperty : editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-combo
				#WhoAmIInput
				id="WhoAmIInput"
				[isDisabled]="isDisabled"
				[options]="whoAmIOptions"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[value]="currentPropertyObject?.WhoAmI"
				(userChange)="setObjectPropertyValue('WhoAmI', $event)"
			/>
		}
		
		@if ('Platform' | displayAuthoringProperty : editorClass : propertyConstructor.namespace) {
			<ada-authoring-property-label
				#PlatformLabel
				content="Platform"
				id="PlatformLabel"
				[inheriting]="currentPropertyObject?.Platform | inheritPipe: inheritedPropertyObject?.Platform"
				[isDisabled]="isDisabled || (editorClass | adaIsSoftwareProduct) === false"
				[isRequired]="'Platform' | isRequiredProperty : editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('Platform')"
			/>
			<ada-combo
				#PlatformInput
				data-testid="general-properties-platform-combo"
				id="PlatformInput"
				[isDisabled]="isDisabled || (editorClass | adaIsSoftwareProduct) === false"
				[options]="platformOptions"
				[placeholder]="inheritedPropertyObject?.Platform | adaGetPlatformName"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[value]="inheritedPropertyObject?.Platform ?? currentPropertyObject?.Platform"
				(userChange)="setPlatform($event)"
			/>
		}

		@if ('PackageName' | displayAuthoringProperty : editorClass : propertyConstructor.namespace) {
			@if (((editorClass | adaIsSoftwareProduct) ? currentPropertyObject : inheritedPropertyObject)?.Platform | adaIsMacOrLinux) {
				<ada-authoring-property-label
					#PackageNameLabel
					content="Package Name"
					id="PlatformNameLabel"
					[inheriting]="currentPropertyObject?.PackageName | inheritPipe: inheritedPropertyObject?.PackageName"
					[isDisabled]="isDisabled || (editorClass | adaIsSoftwareProduct) === false"
					[isRequired]="'PackageName' | isRequiredProperty : editorClass : propertyConstructor.namespace"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
					(inheritanceChange)="deleteObjectPropertyValue('PackageName')"
				/>
				<ada-input
					#PackageNameInput
					data-testid="general-properties-package-name-input"
					id="PackageNameInput"
					placeholder="Package Name (e.g. adcli)"
					type="text"
					[isDisabled]="isDisabled || (editorClass | adaIsSoftwareProduct) === false"
					[maxCharacterLimit]="255"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
					[showAsFullWidth]="true"
					[value]="(currentPropertyObject?.PackageName !== undefined) ? currentPropertyObject?.PackageName : inheritedPropertyObject?.PackageName"
					(userInput)="setObjectPropertyValue('PackageName', $event)"
				/>
			}
		}

		@if ('FeedType' | displayAuthoringProperty: editorClass: propertyConstructor.namespace) {
			<ada-authoring-property-label
				#FeedTypeLabel
				content="Feed Type"
				id="FeedTypeLabel"
				[inheriting]="currentPropertyObject?.FeedType | inheritPipe: inheritedPropertyObject?.FeedType"
				[isDisabled]="isDisabled || (editorClass | adaIsSoftwareProduct) === false"
				[isRequired]="'FeedType' | isRequiredProperty : editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('FeedType')"
			/>
			<ada-combo
				#FeedTypeInput
				data-testid="general-properties-feed-type-combo"
				id="FeedTypeInput"
				[isDisabled]="isDisabled || (editorClass | adaIsSoftwareProduct) === false"
				[options]="feedTypeOptions"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[value]="currentPropertyObject?.FeedType"
				(userChange)="setObjectPropertyValue('FeedType', $event)"
			/>
		}

		@if ('FeedGroup' | displayAuthoringProperty: editorClass: propertyConstructor.namespace) {
			<ada-authoring-property-label
				#FeedGroupLabel
				content="Feed Group"
				id="FeedGroupLabel"
				[inheriting]="currentPropertyObject?.FeedGroup | inheritPipe: inheritedPropertyObject?.FeedGroup"
				[isDisabled]="isDisabled || (editorClass | adaIsSoftwareProduct) === false"
				[isRequired]="'FeedGroup' | isRequiredProperty : editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('FeedGroup')"
			/>

			<ada-input
				#FeedGroupInput
				data-testid="general-properties-feed-group-input"
				id="FeedGroupInput"
				placeholder="Feed Group Name"
				type="text"
				[isDisabled]="isDisabled"
				[maxCharacterLimit]="255"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[showAsFullWidth]="true"
				[value]="(currentPropertyObject?.FeedGroup !== undefined) ? currentPropertyObject?.FeedGroup : inheritedPropertyObject?.FeedGroup"
				(userInput)="setObjectPropertyValue('FeedGroup', $event)"
			/>
		}
	</ada-container>
</ada-card>
